export class PagedResult<TModel> {
	pageInfo: PageInfo = new PageInfo();
	items: TModel[] = [];
}

export class PageInfo {
	page: number = 1;
	pageSize: number = 25;
	totalCount: number = 0;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/paging.ts